import { TENANT_ID } from "./creAuthConfig";

const CIAM_HOST = "creenterprise.ciamlogin.com";

export function isCreAccount(account) {
  if (!account) return false;
  if (account.tenantId === TENANT_ID) return true;

  const env = String(account.environment || "").toLowerCase();
  if (env.includes(CIAM_HOST) || env.includes(TENANT_ID.toLowerCase())) {
    return true;
  }

  const homeId = String(account.homeAccountId || "").toLowerCase();
  return homeId.includes(TENANT_ID.toLowerCase());
}

export function getCreAccounts(msalInstance) {
  return msalInstance.getAllAccounts().filter(isCreAccount);
}

export function getCreActiveAccount(msalInstance) {
  const valid = getCreAccounts(msalInstance);
  if (valid.length === 0) return null;

  const active = msalInstance.getActiveAccount();
  if (active && isCreAccount(active)) return active;

  return valid[0];
}

export async function syncCreActiveAccount(msalInstance) {
  const all = msalInstance.getAllAccounts();
  const valid = all.filter(isCreAccount);

  const active = msalInstance.getActiveAccount();
  if (active && !isCreAccount(active)) {
    msalInstance.setActiveAccount(null);
  }

  if (valid.length > 0 && !msalInstance.getActiveAccount()) {
    msalInstance.setActiveAccount(valid[0]);
  }

  return valid;
}
